(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.footer-content').forEach((root) => {
    root.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;

        if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('menu__details') || !details.open) {
          return;
        }

        // Matches the same breakpoint accordion-custom.js uses (mediaQueryLarge) to decide
        // whether the footer accordion is interactive at all — see assets/accordion-custom.js.
        if (window.matchMedia('(min-width: 1024px)').matches) {
          return;
        }

        root.querySelectorAll('.menu__details[open]').forEach((otherDetails) => {
          if (otherDetails === details) return;

          otherDetails.classList.add('is-closing');

          setTimeout(() => {
            otherDetails.open = false;
          }, 10);

          const removeClosingClass = () => {
            otherDetails.classList.remove('is-closing');
            otherDetails.removeEventListener('transitionend', removeClosingClass);
          };

          otherDetails.addEventListener('transitionend', removeClosingClass, { once: true });
          setTimeout(removeClosingClass, 500);
        });
      },
      true
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
